import styled, { css } from "styled-components";
export const PriceViewGridBase = styled.section `
	margin: 10px 0;
	.currentPrice {
		height: 19px;
		font-size: 14px;
		font-family: Avenir-Black, Avenir;
		font-weight: 900;
		color: #333333;
		line-height: 19px;
	}
	.originPrice {
		font-size: 12px;
		height: 16px;
		line-height: 16px;
		margin-left: 9px;
		text-decoration: line-through;
		vertical-align: middle;
		font-family: Avenir-Roman, Avenir;
		font-weight: normal;
		color: #999999;
	}
	${(props) => {
    if (props.isFlash) {
        return css `
				.originPrice {
					font-family: Avenir-heavy;
				}
			`;
    }
    return css ``;
}}
`;
